import { useKnockFeed as p, useTranslations as m } from "@knocklabs/react-core";
import t, { useCallback as u } from "react";
import { usePopperTooltip as v } from "react-popper-tooltip";
import { CloseCircle as b } from "../../../core/components/Icons/CloseCircle.mjs";
const g = ({
  item: e
}) => {
  const {
    colorMode: o,
    feedClient: n
  } = p(), {
    t: r
  } = m(), a = u(
    (i) => {
      i.preventDefault(), i.stopPropagation(), n.markAsArchived(e);
    },
    // TODO: Check if we can remove this disable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), {
    getTooltipProps: c,
    setTooltipRef: l,
    setTriggerRef: s,
    visible: f
  } = v({
    placement: "top-end"
  });
  return /* @__PURE__ */ t.createElement("button", { ref: s, onClick: a, type: "button", "aria-label": r("archiveNotification"), className: `rnf-archive-notification-btn rnf-archive-notification-btn--${o}` }, /* @__PURE__ */ t.createElement(b, null), f && /* @__PURE__ */ t.createElement("div", { ref: l, ...c({
    className: `rnf-tooltip rnf-tooltip--${o}`
  }) }, r("archiveNotification")));
};
export {
  g as ArchiveButton
};
//# sourceMappingURL=ArchiveButton.mjs.map
